import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4688 7.52344L10.474 7.52344L10.474 1.52873",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.53003 10.4727L7.52473 10.4727L7.52473 16.4674",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6417 7.42085L17 1.0625",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.35713 10.5792L0.998779 16.9375",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		})
	]
});
export default SvgCloseIcon;
